// removed by extract-text-webpack-plugin
module.exports = {"root":"clip-search-form__root","header":"clip-search-form__header","title":"clip-search-form__title","content":"clip-search-form__content","input":"clip-search-form__input","submit":"clip-search-form__submit","searchIcon":"clip-search-form__searchIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/clip-search-form/styles.less
// module id = 486
// module chunks = 1